/**
 * Default middleware handle access to route
 */
export default defineNuxtRouteMiddleware((to) => {
  const fetchApi = useFetchApi();

  if (to.name === "authentification") {
    if (fetchApi.accessStore.token) {
      return navigateTo("/");
    }
  } else if (!fetchApi.accessStore.token) {
    const navigationStore = useNavigationStore();
    navigationStore.redirect = { url: to.fullPath };
    return navigateTo("/authentification");
  }
});
